// extracted by mini-css-extract-plugin
module.exports = {"loading":"_1nTcWMnfzXsYh8hOtWq0AG","addDebtButton":"_2WaCUbXl-W3U2Z_T_FRtsI"};